import React, { useState, useEffect, useRef } from "react";
import "./products.css";

import Avation1 from "../Assets/avation1.png";

import { useStateContext } from "../contexts/ContextProvider";
import ProductsBanner from "./ProductsBanner";

const LMS = () => {
  const { handleShowContact } = useStateContext();

  const title = "Learning Management System";
  const body =
    "Ready to enhance your organization's learning experience? With Fidus LMS, the possibilities are limitless. Let's explore the features that enable it all";

  const vidRef1 = useRef(null);
  const vidRef2 = useRef(null);
  const vidRef3 = useRef(null);
  const vidRef4 = useRef(null);

  const handlePlay = (ref) => {
    console.log("play", ref.current.paused);
    if (ref && ref.current) {
      if (ref.current.paused) {
        // setPlay(true);
        ref.current.play();
      } else {
        // setPlay(false);
        ref.current.pause();
      }
    }
  };

  // const handlePlay = (ref) => {
  //   if (ref.current) {
  //     ref.current.play();
  //   }
  // };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Optional, for animated scrolling
    });
  }, []);
  return (
    <>
      <ProductsBanner product="lms" title={title} body={body} />
      {/* <div className="product-section">
        <div className="product-container">
          <div className="row">
            <div className="col-lg-12">
              <div className="heading">
                <h2>Learning Management System</h2>
                <div className="back-circle"></div>
              </div>
            </div>
          </div>
          <div className="product-bg">
            <div className="row">
              <div className="col-lg-12">
                <div className="product-content">
                  <p>
                    Ready to enhance your organization's learning experience?
                  </p>
                  <p>
                    With Fidus LMS, the possibilities are limitless. Let's
                    explore the features that enable it all
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <div className="product-section">
        <div className="product-container">
          <div className="product-text">
            <div className="row">
              <div className="col-lg-4">
                <div className="box">
                  <div className="box-cover">
                    <div className="content">
                      <h3>Customization & Branding</h3>
                      <p>
                        Fidus LMS offers complete white labeling and
                        customization options, ensuring alignment with employer
                        branding. Every aspect, from features to color schemes
                        to customizable themes, can be tailored to reflect the
                        organization's identity.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-8">
                <div className="figure play">
                  <div className="player">
                    <video
                      ref={vidRef1}
                      // controls
                      controlsList="nodownload"
                      muted
                    >
                      <source src="https://fidusindia.in/assets/videos/lms1.mp4" />
                    </video>
                  </div>

                  {/* <div className="domain-overlay"></div> */}
                  <div className="play" onClick={() => handlePlay(vidRef1)} >
                    <svg
                      width="96"
                      height="96"
                      viewBox="0 0 91 91"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_1736_7903)">
                        <g filter="url(#filter0_d_1736_7903)">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M45.4997 83.4167C66.4403 83.4167 83.4164 66.4407 83.4164 45.5C83.4164 24.5592 66.4403 7.58337 45.4997 7.58337C24.5589 7.58337 7.58301 24.5592 7.58301 45.5C7.58301 66.4407 24.5589 83.4167 45.4997 83.4167ZM40.5459 60.082L58.4433 49.5154C61.4072 47.7652 61.4072 43.2349 58.4433 41.4847L40.5459 30.918C37.665 29.2171 34.1247 31.431 34.1247 34.9333V56.0667C34.1247 59.569 37.665 61.783 40.5459 60.082Z"
                            fill="#05A9A6"
                          />
                        </g>
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_1736_7903"
                          x="3.58301"
                          y="7.58337"
                          width="83.833"
                          height="83.8334"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="4" />
                          <feGaussianBlur stdDeviation="2" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_1736_7903"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_1736_7903"
                            result="shape"
                          />
                        </filter>
                        <clipPath id="clip0_1736_7903">
                          <rect width="91" height="91" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
            <div className="h-200 one"></div>
            <div className="row alternate">
              <div className="col-lg-8">
                <div className="figure play">
                  <div className="player">
                    <video
                      ref={vidRef2}
                      // controls
                      controlsList="nodownload"
                      muted
                    >
                      <source src="https://fidusindia.in/assets/videos/lms2.mp4" />
                    </video>
                  </div>

                  {/* <div className="domain-overlay"></div> */}
                  <div className="play" onClick={() => handlePlay(vidRef2)}>
                    <svg
                      width="96"
                      height="96"
                      viewBox="0 0 91 91"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_1736_7903)">
                        <g filter="url(#filter0_d_1736_7903)">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M45.4997 83.4167C66.4403 83.4167 83.4164 66.4407 83.4164 45.5C83.4164 24.5592 66.4403 7.58337 45.4997 7.58337C24.5589 7.58337 7.58301 24.5592 7.58301 45.5C7.58301 66.4407 24.5589 83.4167 45.4997 83.4167ZM40.5459 60.082L58.4433 49.5154C61.4072 47.7652 61.4072 43.2349 58.4433 41.4847L40.5459 30.918C37.665 29.2171 34.1247 31.431 34.1247 34.9333V56.0667C34.1247 59.569 37.665 61.783 40.5459 60.082Z"
                            fill="#05A9A6"
                          />
                        </g>
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_1736_7903"
                          x="3.58301"
                          y="7.58337"
                          width="83.833"
                          height="83.8334"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="4" />
                          <feGaussianBlur stdDeviation="2" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_1736_7903"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_1736_7903"
                            result="shape"
                          />
                        </filter>
                        <clipPath id="clip0_1736_7903">
                          <rect width="91" height="91" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>
              </div>
              <div className="col-lg-4">
                <div className="box">
                  <div className="box-cover">
                    <div className="content">
                      <h3>Administrative Automation</h3>
                      <p>
                        Fidus LMS streamlines learning program execution by
                        automating administrative tasks like course marketing,
                        learner notifications, and completion reminders. This
                        ensures a seamless learning journey for employees.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="h-200 two"></div>
            <div className="row alternate2">
              <div className="col-lg-6"></div>
              <div className="col-lg-6">
                <div className="figure play">
                  <div className="player">
                    <video
                      ref={vidRef3}
                      // controls
                      controlsList="nodownload"
                      muted
                    >
                      <source src="https://fidusindia.in/assets/videos/lms3.mp4" />
                    </video>
                  </div>

                  {/* <div className="domain-overlay"></div> */}
                  <div className="play" onClick={() => handlePlay(vidRef3)}>
                    <svg
                      width="96"
                      height="96"
                      viewBox="0 0 91 91"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_1736_7903)">
                        <g filter="url(#filter0_d_1736_7903)">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M45.4997 83.4167C66.4403 83.4167 83.4164 66.4407 83.4164 45.5C83.4164 24.5592 66.4403 7.58337 45.4997 7.58337C24.5589 7.58337 7.58301 24.5592 7.58301 45.5C7.58301 66.4407 24.5589 83.4167 45.4997 83.4167ZM40.5459 60.082L58.4433 49.5154C61.4072 47.7652 61.4072 43.2349 58.4433 41.4847L40.5459 30.918C37.665 29.2171 34.1247 31.431 34.1247 34.9333V56.0667C34.1247 59.569 37.665 61.783 40.5459 60.082Z"
                            fill="#05A9A6"
                          />
                        </g>
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_1736_7903"
                          x="3.58301"
                          y="7.58337"
                          width="83.833"
                          height="83.8334"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="4" />
                          <feGaussianBlur stdDeviation="2" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_1736_7903"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_1736_7903"
                            result="shape"
                          />
                        </filter>
                        <clipPath id="clip0_1736_7903">
                          <rect width="91" height="91" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="box">
                  <div className="box-cover">
                    <div className="content">
                      <h3>Comprehensive Learning Features</h3>
                      <p>
                        The platform supports blended learning with integrated
                        virtual classrooms for instructor-led training and
                        discussions, automatic course deactivation, and an
                        e-store for easy access to learning resources.
                        Responsive design, and an easy course creation process
                        enhance user experience. Additionally, customizable
                        certificates, reports, and analytics provide valuable
                        insights into learner progress and course effectiveness,
                        with support for SCORM package 1.2.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="h-200 one"></div>
            <div className="row alternate3">
              <div className="col-lg-6">
                <div className="figure play">
                  <div className="player">
                    <video
                      ref={vidRef4}
                      // controls
                      controlsList="nodownload"
                      muted
                    >
                      <source src="https://fidusindia.in/assets/videos/lms4.mp4" />
                    </video>
                  </div>

                  {/* <div className="domain-overlay"></div> */}
                  <div className="play" onClick={() => handlePlay(vidRef4)}>
                    <svg
                      width="96"
                      height="96"
                      viewBox="0 0 91 91"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_1736_7903)">
                        <g filter="url(#filter0_d_1736_7903)">
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M45.4997 83.4167C66.4403 83.4167 83.4164 66.4407 83.4164 45.5C83.4164 24.5592 66.4403 7.58337 45.4997 7.58337C24.5589 7.58337 7.58301 24.5592 7.58301 45.5C7.58301 66.4407 24.5589 83.4167 45.4997 83.4167ZM40.5459 60.082L58.4433 49.5154C61.4072 47.7652 61.4072 43.2349 58.4433 41.4847L40.5459 30.918C37.665 29.2171 34.1247 31.431 34.1247 34.9333V56.0667C34.1247 59.569 37.665 61.783 40.5459 60.082Z"
                            fill="#05A9A6"
                          />
                        </g>
                      </g>
                      <defs>
                        <filter
                          id="filter0_d_1736_7903"
                          x="3.58301"
                          y="7.58337"
                          width="83.833"
                          height="83.8334"
                          filterUnits="userSpaceOnUse"
                          color-interpolation-filters="sRGB"
                        >
                          <feFlood
                            flood-opacity="0"
                            result="BackgroundImageFix"
                          />
                          <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                            result="hardAlpha"
                          />
                          <feOffset dy="4" />
                          <feGaussianBlur stdDeviation="2" />
                          <feComposite in2="hardAlpha" operator="out" />
                          <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                          />
                          <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow_1736_7903"
                          />
                          <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow_1736_7903"
                            result="shape"
                          />
                        </filter>
                        <clipPath id="clip0_1736_7903">
                          <rect width="91" height="91" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>
              </div>
              <div className="col-lg-6"></div>

              <div className="col-lg-12">
                <div className="box">
                  <div className="box-cover">
                    <div className="content">
                      <h3>Ongoing Enhancements</h3>
                      <p>
                        Fidus LMS continuously evolves to meet the needs of
                        modern workplaces. This includes integration of payment
                        gateways for seamless transactions and continuous
                        improvements such as enhanced reports, easy course
                        access, and advanced analytics for personalized
                        insights.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="cta">
        <div className="cta-flex" onClick={handleShowContact}>
          <h4>Let's Get In Touch</h4>
          <svg
            width="46"
            height="47"
            viewBox="0 0 46 47"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M13.417 33.0834L32.5837 13.9167M32.5837 13.9167H15.3337M32.5837 13.9167V31.1668"
              stroke="#15ADAA"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>
    </>
  );
};

export default LMS;
